import { forwardRef, useState } from 'react';
import { InfoIcon } from '../../../images/icons/InfoIcon';
import { Colors } from '../../../themes/colors';

import './styles.scss';

const Tooltip = forwardRef(({ content, placement = 'right' }, ref) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleMouseEnter = () => {
    setIsTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipVisible(false);
  };

  return (
    <div className="tooltip-wrapper">
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} ref={ref}>
        <InfoIcon color={Colors.neutral_300} />
      </div>

      <div className={`tooltip ${placement} ${isTooltipVisible ? 'visible' : ''}`}>{content}</div>
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
